(function () {
if (window.gigiFlavourFilter?.init) {
  window.gigiFlavourFilter.init();
  return;
}

class GigiFlavourFilter {
  constructor() {
    this.onChange = this.onChange.bind(this);
    this.onGridUpdate = this.onGridUpdate.bind(this);
    this.selectedIds = new Set();
  }

  init() {
    const nextGridContainer = document.getElementById('ProductGridContainer');
    if (!nextGridContainer) {
      this.observer?.disconnect();
      this.observer = null;
      this.gridContainer = null;
      return;
    }

    if (this.gridContainer !== nextGridContainer) {
      this.observer?.disconnect();
      this.observer = null;
      this.gridContainer = nextGridContainer;
    }

    document.querySelectorAll('.gigi-flavour-filter__input').forEach((input) => {
      input.removeEventListener('change', this.onChange);
      input.addEventListener('change', this.onChange);
    });

    if (!this.observer) {
      this.observer = new MutationObserver(this.onGridUpdate);
      this.observer.observe(this.gridContainer, { childList: true, subtree: true });
    }

    this.syncSelectedFromInputs();
    this.applyFilter();
  }

  syncSelectedFromInputs() {
    this.selectedIds.clear();
    document.querySelectorAll('.gigi-flavour-filter__input:checked').forEach((input) => {
      this.selectedIds.add(input.value);
    });
  }

  syncInputsFromSelected() {
    document.querySelectorAll('.gigi-flavour-filter__input').forEach((input) => {
      input.checked = this.selectedIds.has(input.value);
    });
  }

  onChange(event) {
    const input = event.target;
    if (!input.classList.contains('gigi-flavour-filter__input')) return;

    if (input.checked) {
      this.selectedIds.add(input.value);
    } else {
      this.selectedIds.delete(input.value);
    }

    this.syncInputsFromSelected();
    this.applyFilter();
    input.blur();
  }

  resetAll() {
    this.selectedIds.clear();
    this.syncInputsFromSelected();
    this.applyFilter();
  }

  onGridUpdate() {
    this.applyFilter();
  }

  applyFilter() {
    const grid = this.gridContainer?.querySelector('#product-grid');
    if (!grid) return;

    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.applyCurrentClientFilters(this.gridContainer)) {
      return;
    }

    const emptyState = this.gridContainer.querySelector('.gigi-collection-search-empty');
    const searchInput = document.querySelector('.gigi-collection-toolbar__search-input');
    const searchQuery = searchInput?.value.trim().toLowerCase() || '';
    let visibleCount = 0;

    grid.querySelectorAll('.grid__item').forEach((item) => {
      const title = item.querySelector('.card__heading')?.textContent.trim().toLowerCase() || '';
      const matchesSearch = !searchQuery || title.includes(searchQuery);

      const flavourIds = (item.dataset.gigiFlavourIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);

      const matchesFlavour =
        this.selectedIds.size === 0 || flavourIds.some((id) => this.selectedIds.has(id));

      const matches = matchesSearch && matchesFlavour;
      item.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    const showEmpty = (searchQuery.length > 0 || this.selectedIds.size > 0) && visibleCount === 0;
    emptyState?.classList.toggle('hidden', !showEmpty);
    grid.classList.toggle('gigi-collection-search--empty', showEmpty);

    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.updateClearAllState();
    }
  }
}

const gigiFlavourFilter = new GigiFlavourFilter();
window.gigiFlavourFilter = gigiFlavourFilter;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => gigiFlavourFilter.init(), { once: true });
} else {
  gigiFlavourFilter.init();
}
document.addEventListener('shopify:section:load', () => gigiFlavourFilter.init());
})();
